export default function dec2bin(dec) {
  const [_, ...bin] = Array.from((dec >>> 0).toString(2)).reverse();
  return bin;
}
